import ServiceBase from './serviceBase';
import { OperationMembersFilter, OperationMembersHistory, OpMemberReq } from './types/Member';

class OperMemberService extends ServiceBase {
  getHistory = async (filter: OperationMembersFilter): Promise<OperationMembersHistory> =>
    this.post<OperationMembersHistory>(`operationmembers/${filter.operationId}/history`, filter);

  saveMembers = async (operationId: number, members: OpMemberReq[]): Promise<void> =>
    this.post<void>(`operationmembers/${operationId}/save`, members);
}

const operMemberService = new OperMemberService();

export default operMemberService;
